import Component from './component';

Component.defaultProps = {
    initialValues: {},
};
export default Component;
